module.exports = __webpack_public_path__ + "./fonts/Hackney-Vector.ttf";